// ─── AJAX Add to Cart ────────────────────────────────────────────────
async function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  try {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    if (!response.ok) throw new Error('Add to cart failed');
    var item = await response.json();

    // Update cart count
    var cartData = await fetch('/cart.js').then(function(r) { return r.json(); });
    var cartCount = document.getElementById('cart-count');
    if (cartCount) cartCount.textContent = cartData.item_count;

    // Dispatch event for other components
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { count: cartData.item_count, item: item }
    }));

    // Visual feedback on button
    var btn = document.querySelector('[data-product-id="' + variantId + '"]');
    if (btn) {
      var originalText = btn.textContent;
      btn.textContent = '✓ Adăugat în coș!';
      btn.disabled = true;
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }

    return item;
  } catch (error) {
    console.error('Add to cart error:', error);
  }
}

// Event listeners for all ATC buttons
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-product-id]');
  if (!btn) return;
  e.preventDefault();
  var variantId = btn.dataset.productId;
  if (variantId) addToCart(variantId);
});

// ─── Sticky ATC visibility ───────────────────────────────────────────
// Appears after user scrolls past the main ATC button
var stickyAtc  = document.getElementById('sticky-atc');
var mainAtcBtn = document.getElementById('main-atc-btn');

if (stickyAtc && mainAtcBtn) {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var isVisible = !entry.isIntersecting;
      stickyAtc.classList.toggle('is-visible', isVisible);
      stickyAtc.setAttribute('aria-hidden', !isVisible);
    });
  }, { threshold: 0 });
  observer.observe(mainAtcBtn);
}

// ─── Accordion (product details) ─────────────────────────────────────
document.querySelectorAll('.accordion-head').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    // Close others
    document.querySelectorAll('.accordion-head').forEach(function(other) {
      if (other !== btn) {
        other.setAttribute('aria-expanded', 'false');
        other.nextElementSibling.hidden = true;
      }
    });
    btn.setAttribute('aria-expanded', !expanded);
    btn.nextElementSibling.hidden = expanded;
  });
});

// ─── Smooth scroll for anchor links ─────────────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
